import * as Actions from '../actions/actions';
import * as ActionTypes from '../actions/actiontypes';
import * as Service from '../services/services';
import { takeEvery, call, put } from 'redux-saga/effects';

export function* fetchRouteSummary(action) {
    const startTime = Date.now();
    try {
        console.log(`[LVD] Requesting Route Summary with filters:`, action.payload.filters);
        
        const response = yield call(
            Service.getRouteSummary,
            action.payload.authToken,
            action.payload.filters,
            action.payload.pagination,
            action.payload.sorting
        );
        
        const responseTime = Date.now() - startTime;
        
        console.log(`[LVD] Route Summary loaded in ${responseTime}ms`);
        
        if (responseTime > 5000) {
            console.warn(`[LVD] Performance warning: Route Summary took ${responseTime}ms`);
        }
        
        yield put(Actions.LOAD_ROUTE_SUMMARY_SUCCESS(
            response.data.data,
            response.data.total_count,
            response.data.page,
            response.data.page_size,
            responseTime
        ));
    } catch (error) {
        const responseTime = Date.now() - startTime;
        
        if (error.code === 'ECONNABORTED') {
            console.error('[LVD] Route Summary timeout after 30s. Request params:', action.payload);
        } else {
            console.error('[LVD] Route Summary error:', error.response?.status, error.message, 'Request params:', action.payload);
        }
        
        yield put(Actions.LOAD_ROUTE_SUMMARY_ERROR(error));
    }
}

export function* fetchRouteDetails(action) {
    const startTime = Date.now();
    try {
        console.log(`[LVD] Requesting Route Details with filters:`, action.payload.filters);
        
        const response = yield call(
            Service.getRouteDetails,
            action.payload.authToken,
            action.payload.filters,
            action.payload.pagination,
            action.payload.sorting
        );
        
        const responseTime = Date.now() - startTime;
        
        console.log(`[LVD] Route Details loaded in ${responseTime}ms`);
        
        if (responseTime > 5000) {
            console.warn(`[LVD] Performance warning: Route Details took ${responseTime}ms`);
        }
        
        yield put(Actions.LOAD_ROUTE_DETAILS_SUCCESS(
            response.data.data,
            response.data.total_count,
            response.data.page,
            response.data.page_size,
            responseTime
        ));
    } catch (error) {
        const responseTime = Date.now() - startTime;
        
        if (error.code === 'ECONNABORTED') {
            console.error('[LVD] Route Details timeout after 30s. Request params:', action.payload);
        } else {
            console.error('[LVD] Route Details error:', error.response?.status, error.message, 'Request params:', action.payload);
        }
        
        yield put(Actions.LOAD_ROUTE_DETAILS_ERROR(error));
    }
}

export function* fetchDoorDetails(action) {
    const startTime = Date.now();
    try {
        console.log(`[LVD] Requesting Door Details with filters:`, action.payload.filters);
        
        const response = yield call(
            Service.getDoorDetails,
            action.payload.authToken,
            action.payload.filters,
            action.payload.pagination,
            action.payload.sorting
        );
        
        const responseTime = Date.now() - startTime;
        
        console.log(`[LVD] Door Details loaded in ${responseTime}ms`);
        
        if (responseTime > 5000) {
            console.warn(`[LVD] Performance warning: Door Details took ${responseTime}ms`);
        }
        
        yield put(Actions.LOAD_DOOR_DETAILS_SUCCESS(
            response.data.data,
            response.data.total_count,
            response.data.page,
            response.data.page_size,
            responseTime
        ));
    } catch (error) {
        const responseTime = Date.now() - startTime;
        
        if (error.code === 'ECONNABORTED') {
            console.error('[LVD] Door Details timeout after 30s. Request params:', action.payload);
        } else {
            console.error('[LVD] Door Details error:', error.response?.status, error.message, 'Request params:', action.payload);
        }
        
        yield put(Actions.LOAD_DOOR_DETAILS_ERROR(error));
    }
}

export function* fetchFilterOptions(action) {
    try {
        const response = yield call(
            Service.getFilterOptions,
            action.payload.authToken
        );
        
        yield put(Actions.LOAD_LVD_FILTER_OPTIONS_SUCCESS(response.data));
    } catch (error) {
        console.error('[LVD] Filter Options error:', error.response?.status, error.message);
        yield put(Actions.LOAD_LVD_FILTER_OPTIONS_ERROR(error));
    }
}

export function* fetchRouteList(action) {
    try {
        const response = yield call(
            Service.getRouteList,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_ROUTE_LIST_SUCCESS(response.data.data || []));
    } catch (error) {
        console.error('[LVD] Route List error:', error.message);
        yield put(Actions.LOAD_ROUTE_LIST_ERROR(error));
    }
}

export function* fetchDoorList(action) {
    try {
        const response = yield call(
            Service.getDoorList,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_DOOR_LIST_SUCCESS(response.data.data || []));
    } catch (error) {
        console.error('[LVD] Door List error:', error.message);
        yield put(Actions.LOAD_DOOR_LIST_ERROR(error));
    }
}

export function* EffectListener() {
    yield takeEvery(ActionTypes.LOAD_ROUTE_SUMMARY, fetchRouteSummary);
    yield takeEvery(ActionTypes.LOAD_ROUTE_DETAILS, fetchRouteDetails);
    yield takeEvery(ActionTypes.LOAD_DOOR_DETAILS, fetchDoorDetails);
    yield takeEvery(ActionTypes.LOAD_LVD_FILTER_OPTIONS, fetchFilterOptions);
    yield takeEvery(ActionTypes.LOAD_ROUTE_LIST, fetchRouteList);
    yield takeEvery(ActionTypes.LOAD_DOOR_LIST, fetchDoorList);
}
